import { Component } from '@angular/core';
import { OnInit } from "@angular/core";
import { Router } from '@angular/router';

import { contactViewPipe } from '../pipes/phone-view.pipe';

import { SessionStorageService } from "../shared/services/session-storage.service";
import { VCPatientDetailsService } from './virtual-consultation-patient-details.services';
import { SnackbarService } from "./../shared/services/snackbar.service";
import { SharedService } from '../shared/services/shared.service';

@Component({
    template: require('./virtual-consultation-patient-details.component.html'),
    styles: [require('./virtual-consultation-patient-details.component.less')],
    preserveWhitespaces: true,
    providers: [VCPatientDetailsService, SnackbarService, contactViewPipe]
})

export class VCPatientDetailsComponent implements OnInit {

    constructor(
        private _mdlSnackbarService: SnackbarService,
        private _sessionStorageService: SessionStorageService ,
        private contactViewPipe: contactViewPipe,
        private _router: Router,
        private _vcPatientDetailService: VCPatientDetailsService,
        private _sharedService:SharedService
        ) { }

    loading: boolean = false;
    vcType: any;
    isMobile: boolean = false;
    _patientfile: any = {};
    fixedHeading: boolean = false;
    photoSection2: boolean = false;
    loaded: boolean = false;
    imageNames = [
        "Smile",
        "Front Teeth",
        "Front Teeth - Apart",
        "Right Side",
        "Left Side",
        "Upper Teeth",
        "Lower Teeth",
      ];
    imageIdNames = ['smile_image_id', 'anterior_image_id', 'anterior_teeth_apart_image_id', 'right_brucal_image_id', 'left_brucal_image_id', 'upper_occlusal_image_id', 'lower_occlusal_image_id'];
    imageIdNamesAlignersIn = ['anterior_with_aligner_image_id', 'anterior_teeth_apart_with_aligner_image_id', 'right_brucal_aligner_image_id', 'left_brucal_aligner_image_id'];
    nextClickedClass = '';
    prevClickedClass = '';
    image: any ='';
    locationName: string;
    doctorName: string;
    stateName: string;
    stateNameSecondaryRP: string;
    referralMethod: any;
    relationShipMap: any = {
        'STEP-MOTHER': 'STEP_MOTHER',
        'STEP-FATHER': 'STEP_FATHER',
        'MOTHER': 'MOTHER',
        'FATHER': 'FATHER',
        'OTHER': 'OTHER',
        'GUARDIAN': 'GUARDIAN'
    };
    relationShipValue: any;
    relationShipValueSecondaryRP: any;

    responsiblePartyKeyValueFields: any = [
        {key: 'first_name', valueKey: 'responsible_party_first_name'},
        {key: 'middle_name', valueKey: 'responsible_party_middle_name'},
        {key: 'last_name', valueKey: 'responsible_party_last_name'},
        {key: 'dob', valueKey: 'responsible_party_dob'},
        {key: 'relationship_option', valueKey: 'relationship_option'},
        {key: 'email', valueKey: 'email'},
        {key: 'contact_number', valueKey: 'phone_number'},
        {key: 'contact_number_type', valueKey: 'phone_number_type'},
        {key: 'best_contact_method', valueKey: 'best_contact_method'}
    ];

    responsiblePartyMailingAddressKeyValueFields: any =[
        {key: 'street_address1', valueKey: 'mailing_street_address_1'},
        {key: 'street_address2', valueKey: 'mailing_street_address_2'},
        {key: 'city', valueKey: 'city'},
        {key: 'state_id', valueKey: 'state_id'},
        {key: 'zip', valueKey: 'zip_code_postal_code'},
    ];

    adultRPKeyValueFields: any = [
        {key: 'first_name', valueKey: 'first_name'},
        {key: 'middle_name', valueKey: 'middle_name'},
        {key: 'last_name', valueKey: 'last_name'},
        {key: 'dob', valueKey: 'dob'},
        {key: 'email', valueKey: 'email'},
        {key: 'contact_number', valueKey: 'phone_number'},
        {key: 'contact_number_type', valueKey: 'phone_number_type'},
        {key: 'best_contact_method', valueKey: 'best_contact_method'}
    ];

    newConsultationRequestKeys: any = ['adult', 'preferred_treatment_options', 'first_name', 'last_name', 'middle_name',
        'dob', 'gender', 'location_id', 'referral_source_id', 'referral_doctor', 'chief_concern', 'note',
        'smile_image_id', 'anterior_image_id', 'anterior_teeth_apart_image_id', 'right_brucal_image_id',
        'left_brucal_image_id', 'upper_occlusal_image_id', 'lower_occlusal_image_id'];


    checkData() {
        this._sessionStorageService.readItem('vcType').then((type: any) => {
            this.vcType = type;
            this._sessionStorageService.readItem('patientFile').then((data: any) => {
                if(data) {
                    this._patientfile = data;
                    let selectedLocation = this._patientfile.locations.find((location: any) => location.id === this._patientfile.location_id);
                    if (selectedLocation) {
                        this.locationName = selectedLocation.city.name;
                    }
                    let selectedDoctor = selectedLocation.doctor_list.find((doctor: any) => doctor.id === this._patientfile.doctor_id);
                    if (selectedDoctor) {
                        this.doctorName = selectedDoctor.first_name + ' ' + selectedDoctor.last_name;
                    }
                    let selectedReferral = this._patientfile.referral_methods.find((method: any) => method.id === this._patientfile.referral_source_id);
                    if (selectedReferral) {
                        this.referralMethod = selectedReferral.text;
                    }

                    let selectedState = this._patientfile.country.states.find((state: any) => state.id === this._patientfile.state_id);
                    if (selectedState) {
                        this.stateName = selectedState.name;
                    }

                    if (this._patientfile.relationship_option) {
                        this.relationShipValue = this.relationShipMap[this._patientfile.relationship_option.toUpperCase()];
                    }

                    if (this._patientfile.adult === 'no' && this._patientfile.hasSecondaryRP) {
                        let selectedStateSecondaryRP = this._patientfile.country.states.find((state: any) => state.id === this._patientfile.secondary_state_id);
                        if (selectedStateSecondaryRP) {
                            this.stateNameSecondaryRP = selectedStateSecondaryRP.name;
                        }

                        if (this._patientfile.secondary_relationship_option) {
                            this.relationShipValueSecondaryRP = this.relationShipMap[this._patientfile.secondary_relationship_option.toUpperCase()];
                        }
                    }

                    this.loaded = true;
                    if( this._patientfile.chief_concern){
                        if (this._patientfile.chief_concern !== 'Excessive Overjet') {
                            this.image = require('../../assets/images/' + this._patientfile.chief_concern + '.png');
                        } else {
                            this.image = require('../../assets/images/Excessive Overbite.png');
                        }
                    }
                    if (type === 'vc-progress-checkup' && data.has_aligner === 'yes') {
                        this.photoSection2 = true;
                    }
                }
            });
        });
    }

    prevPage() {
        this.prevClickedClass = 'prevClickClass';
        setTimeout(() => {
            this.prevClickedClass = '';
            this._router.navigate(['vc-photo-upload'],{ replaceUrl: true });
        }, 300);
    }

    nextPage() {
        if (this.nextClickedClass !== 'nextClickClass') {
            this.nextClickedClass = 'nextClickClass';
            this.loading = true;
            setTimeout(() => {
                this.nextClickedClass = '';
                if (this.vcType === 'vc-progress-checkup') {
                    for (let i=0; i<this._patientfile.uploadImages.length; ++i) {
                        this._patientfile[this.imageIdNames[i]] = this._patientfile.uploadImages[i].id;
                        if (i<4 && this._patientfile.has_aligner === 'yes') {
                            this._patientfile[this.imageIdNamesAlignersIn[i]] = this._patientfile.uploadImagesAlignersIn[i].id;
                        }
                    }
                } else {
                    for (let i=0; i<this._patientfile.uploadImages.length; ++i) {
                        this._patientfile[this.imageIdNames[i]] = this._patientfile.uploadImages[i].id;
                    }
                }

                let requestData: any;

                if (this.vcType === 'vc-new-consultation') {
                    requestData = this.getVCNewConsultationRequestData(this._patientfile);
                } else {
                    requestData = JSON.parse(JSON.stringify(this._patientfile));
                    requestData['email_address'] = requestData.email;
                    requestData['street_address1'] = requestData.mailing_street_address_1;
                    if (requestData.mailing_street_address_2?.trim()) {
                        requestData['street_address2'] = requestData.mailing_street_address_2;
                    }

                    if (this.vcType === 'vc-progress-checkup') {
                        if (requestData.has_aligner === 'yes') {
                            requestData.has_aligner = true;
                        } else {
                            requestData.has_aligner = false;
                        }
                    }

                    if (this.vcType === 'vc-emergency-checkup') {
                        requestData.uploadImages = requestData.uploadImages.filter((image: any)  => image.uploaded)
                        requestData.uploadImagesAlignersIn = requestData.uploadImagesAlignersIn.filter((image: any)  => image.uploaded)
                    }

                    requestData['zip_code'] = requestData.zip_code_postal_code;
                    if (requestData.adult === "yes") {
                        requestData['relationship'] = "PATIENT";
                        if (requestData.relationship_option) {
                            requestData['relationship_option'] = '';
                        }
                    } else {
                        requestData['relationship'] = "PARENT_GUARDIAN";
                    }

                    if (requestData.relationship_option) {
                        requestData['relationship_option'] = requestData.relationship_option.toUpperCase();
                    }
                    requestData['best_contact_method'] = requestData['best_contact_method'].toLowerCase();
                    requestData['dob'] = this.formatDOB(requestData['dob']);

                    if( requestData.responsible_party_dob) {
                        requestData['responsible_party_dob'] = this.formatDOB(requestData['responsible_party_dob']);
                    }

                    if(requestData.referral_source_id){
                        let selectedReferralMethod = requestData.referral_methods.find((value: any) => value.id === requestData.referral_source_id)
                        if(selectedReferralMethod.text !== "Professional Referral"){
                            delete requestData.referral_doctor;
                        }
                    }

                    //delete middle name if empty
                    if (!requestData.middle_name?.trim()) {
                        delete requestData.middle_name;
                    }

                    // delete keys used in UI only from the payload
                    delete requestData.logo;
                    delete requestData.uploadImages;
                    delete requestData.country;
                    delete requestData.country_list;
                    delete requestData.state;
                    delete requestData.locations;
                    delete requestData.referral_methods;

                    // convert phone format before saving
                    if (requestData.phone_number && (requestData.countryCode === 'US' || requestData.countryCode === 'CA')) {
                        requestData.phone_number = this.contactViewPipe.transform(requestData.phone_number, requestData.countryCode)
                    }
                }

                this._vcPatientDetailService.submitDetails(requestData, this._patientfile.token, this.vcType)
                    .subscribe((res: any) => {
                        this.loading = false;
                        this._router.navigate(['vc-success'],{ replaceUrl: true });
                    }, (error: any) => {
                        this.loading = false;
                        this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG');
                    })
            }, 300);
        }
    }

    getVCNewConsultationRequestData(patientFileData: any) {
        let payload: any = { responsible_parties: [] };

        for (let key of this.newConsultationRequestKeys) {
            if (key === 'middle_name') {
                if (patientFileData[key]?.trim()) {
                    payload[key] = patientFileData[key];
                }
            } else if (patientFileData[key]) {
                payload[key] = patientFileData[key];
            }
        }
        payload['dob'] = this.formatDOB(payload['dob']);

        let responsible_party1 = {}, mailing_address_1 = {};

        if (patientFileData.adult === 'no') {
            for (let key_item of this.responsiblePartyKeyValueFields) {
                if (key_item.key === 'middle_name') {
                    if (patientFileData[key_item.valueKey]?.trim()) {
                        responsible_party1[key_item.key] = patientFileData[key_item.valueKey];
                    }
                } else {
                    responsible_party1[key_item.key] = patientFileData[key_item.valueKey];
                }
            }
        } else {
            for (let key_item of this.adultRPKeyValueFields) {
                if (key_item.key === 'middle_name') {
                    if (patientFileData[key_item.valueKey]?.trim()) {
                        responsible_party1[key_item.key] = patientFileData[key_item.valueKey];
                    }
                } else {
                    responsible_party1[key_item.key] = patientFileData[key_item.valueKey];
                }
            }
        }

        for (let key_item of this.responsiblePartyMailingAddressKeyValueFields) {
            if (key_item.key === 'street_address2') {
                if (patientFileData[key_item.valueKey]?.trim()) {
                    mailing_address_1[key_item.key] = patientFileData[key_item.valueKey];
                }
            } else {
                mailing_address_1[key_item.key] = patientFileData[key_item.valueKey];
            }
        }

        responsible_party1['address'] = mailing_address_1;
        responsible_party1['dob'] = this.formatDOB(responsible_party1['dob']);
        if (patientFileData.adult === 'no') {
            responsible_party1['relationship_option'] = responsible_party1['relationship_option'].toUpperCase();
            responsible_party1['relationship'] = 'PARENT_GUARDIAN';
        } else {
            responsible_party1['relationship_option'] = '';
            responsible_party1['relationship'] = 'PATIENT';
        }
        responsible_party1['best_contact_method'] = responsible_party1['best_contact_method'].toLowerCase();
        responsible_party1['is_primary'] = true;

        if (patientFileData.countryCode === 'US' || patientFileData.countryCode === 'CA') {
            responsible_party1['contact_number'] = this.contactViewPipe.transform(responsible_party1['contact_number'], patientFileData.countryCode)
        }

        payload.responsible_parties[0] = responsible_party1;

        payload = this.setSecondaryRPData(patientFileData, payload);

        return payload;
    }

    setSecondaryRPData(patientFileData: any, payload: any) {
        if (patientFileData.adult === 'no' && patientFileData.hasSecondaryRP) {
            payload.responsible_parties.push({});
            let responsible_party2 = {}, mailing_address_2 = {};

            for (let key_item of this.responsiblePartyKeyValueFields) {
                if (key_item.key === 'middle_name') {
                    if (patientFileData['secondary_' + key_item.valueKey]?.trim()) {
                        responsible_party2[key_item.key] = patientFileData['secondary_' + key_item.valueKey];
                    }
                } else {
                    responsible_party2[key_item.key] = patientFileData['secondary_' + key_item.valueKey];
                }
            }

            for (let key_item of this.responsiblePartyMailingAddressKeyValueFields) {
                if (key_item.key === 'street_address2') {
                    if (patientFileData['secondary_' + key_item.valueKey]?.trim()) {
                        mailing_address_2[key_item.key] = patientFileData['secondary_' + key_item.valueKey];
                    }
                } else {
                    mailing_address_2[key_item.key] = patientFileData['secondary_' + key_item.valueKey];
                }
            }

            responsible_party2['address'] = mailing_address_2;
            responsible_party2['dob'] = this.formatDOB(responsible_party2['dob']);
            responsible_party2['relationship_option'] = responsible_party2['relationship_option'].toUpperCase();
            responsible_party2['best_contact_method'] = responsible_party2['best_contact_method'].toLowerCase();
            responsible_party2['relationship'] = 'PARENT_GUARDIAN';
            responsible_party2['is_primary'] = false;

            if (patientFileData.secondary_country_code === 'US' || patientFileData.secondary_country_code === 'CA') {
                responsible_party2['contact_number'] = this.contactViewPipe.transform(responsible_party2['contact_number'], patientFileData.secondary_country_code)
            }

            payload.responsible_parties[1] = responsible_party2;
        }

        return payload;
    }

    formatDOB(dobValue: any) {
        let dobDetails = dobValue.split('/')
        return dobDetails[2] + '-' + dobDetails[0] + '-' + dobDetails[1];
    }

    ngOnInit() {
        let that = this;
        window.addEventListener("scroll", function(event) {
            if (window.scrollY > 50) {
                that.fixedHeading = true;
            } else {
                that.fixedHeading = false;
            }
        });
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
        this.isMobile = this._sharedService.isMobileOrTabletDevice();
        this.checkData();
    }
}